import { Page, PageContent } from './Page';

export default {
  Container: Page,
  Content: PageContent,
};
